<script setup lang="ts">
import { faCheck, type IconDefinition } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  icon: IconDefinition | string
  title: string
  description?: string
  active?: boolean
}>()
</script>

<template>
  <button
    name="recipient-redemption-option"
    class="redemption-option
      p-2 pr-5
      border-2 border-solid border-grey-primary
      hover:border-v2-active hover:bg-v2-active hover:text-white
      rounded-v2md
      flex items-center gap-3
      text-left
      w-full lg:w-[220px]
      group
      transition-colors duration-500 ease-in-out
    "
    :class="active ? 'bg-v2-active text-white border-v2-active' : 'bg-surface-grey text-navy'"
    :title="title"
  >
    <div class="bg-white rounded-v2md">
      <div
        class="
          flex items-center justify-center bg-v2-active bg-opacity-12 rounded-v2md
          h-10 w-10 lg:h-10 lg:w-10
        "
      >
        <GIcon :icon="icon" class="text-v2-active" size="md"/>
      </div>
    </div>
    <div class="flex flex-col gap-2 flex-grow">
      <div class="text-sm font-semibold">{{ title }}</div>
    </div>
    <GIcon
      v-show="active"
      :icon="faCheck"
      class="text-white"
      size="md"
    />
  </button>
</template>

<style scoped lang="scss">
.g-button.redemption-option {
  --height: auto;

  gap: 0.75rem;
  justify-content: start;
  padding: 1rem 1.5rem;
  text-align: left;
  white-space: wrap;
}
</style>
